import ObjectCopyService from "external-services/object-copy-service/index";
import TrackingService from 'app/services/tracking/tracking.service';
import DateUtilsService from "external-services/date-utils-service";
import PouchLoadService from "external-services/pouch-load-service/index";
import TablesLookupService from "external-services/tables-lookup-service/tablesLookup.service";

const NS = 'TablesService'; // jshint ignore:line
// public function: getLayoutById, getByLayouts, getAllLayouts, getLayouts
// private function: getLayoutByDate, getLayoutGroup, getLayoutsGroups, groupLayouts, loadAllLayouts
// above function move to layouts.service.ts
// getAllTablesByIds move to tablesLookup.service.ts
export default function TablesService(
  $q, $rootScope, pouchService
) {
  "ngInject";

  var service = {};

  service.shapes = [{
    name: 'square',
    display: 'Square'
  }, {
    name: 'rect',
    display: 'Rectangle'
  }, {
    name: 'circle',
    display: 'Circle'
  }];

  service.availableOptions = [{
    label: 'All',
    value: 'all'
  }, {
    label: 'Diary Only',
    value: 'diary'
  }, {
    label: 'Walk ins only',
    value: 'walkin'
  }];

  service.tablesLookUp = {};


  // $rootScope.$on('set-up-complete', service.createTableLookUp);
  $rootScope.$on('set-up-complete', () => {
    TablesLookupService.createTableLookup();
  });

  service.init = function () {
    // service.createTableLookUp();
    TablesLookupService.createTableLookup();
  };

  service.checkTablesAvailableOptions = function (tables) {
    for (var i = tables.length - 1; i >= 0; i--) {
      var table = tables[i];
      service.checkAvailableOptions(table);
    }
  };

  service.checkAvailableOptions = function (table) {
    if (table.walkinOnly === null) {
      table.walkinOnly = false;
    }
    if (table.walkinOnly) {
      table.availableOption = 'walkin';
    }
    if (!table.online && !table.walkinOnly) {
      table.availableOption = 'diary';
    }
    if (table.online && !table.walkinOnly) {
      table.availableOption = 'all';
    }
  };

  service.setTablesBookingOptions = function (tables) {
    for (var i = tables.length - 1; i >= 0; i--) {
      var table = tables[i];
      service.setBookingOptions(table);
    }
  };

  service.setBookingOptions = function (table) {
    if (table.availableOption) {
      if (table.availableOption === 'all') {
        table.online = true;
        table.walkinOnly = false;
      }
      if (table.availableOption === 'diary') {
        table.online = false;
        table.walkinOnly = false;
      }
      if (table.availableOption === 'walkin') {
        table.online = false;
        table.walkinOnly = true;
      }
    }
  };

  service.getTableById = function (id) {
    return $q.when(PouchLoadService.getDbLocal().get(id));
  };

  /**
   * Get all the tables that are in this venue
   * @return {Array}
   */
  // service.getAll = function () {
  //   var db = PouchLoadService.getDbLocal();
  //   if (!db) {
  //     return;
  //   }
  //   return $q.when(db.allDocs({
  //     include_docs: true,
  //     attachments: false,
  //     startkey: 'table_',
  //     endkey: 'table_\uffff'
  //   }).then(function (tables) {
  //     return tables.rows.map(function (item) {
  //       return item.doc;
  //     });
  //   }));
  // };

  // /**
  //  * Create a look up of all the tables in a venue
  //  */
  // service.createTableLookUp = function () {
  //   service.tablesLookUp = {};
  //   service.getAll().then(function (tables) {
  //     service.tablesLookUp = {};
  //     var total = tables.length - 1;
  //     for (var i = total; i >= 0; i--) {
  //       var table = tables[i];
  //       service.tablesLookUp[table._id] = table;
  //     }
  //   });
  // };

  /**
   * Deletes a layout
   * @param {id} [String] The id of the layout
   * @return {Promise}
   */
  service.deteleLayout = function (layout) {
    var idParts = layout._id.split('_');
    idParts.pop();
    var layoutId = idParts.join('_');
    return $q.when(PouchLoadService.getDbLocal().allDocs({
      include_docs: true,
      attachments: false,
      startkey: layoutId,
      endkey: layoutId + '\uffff',
    }).then(function (layouts) {
      var layoutsList = [];
      for (var i = layouts.rows.length - 1; i >= 0; i--) {
        var layout = layouts.rows[i].doc;
        layout.hidden = true;
        layoutsList.push(layout);
      }
      TrackingService.trackEvent('Hide layout', {
        id: layoutId
      });
      return PouchLoadService.getDbLocal().bulkDocs(layoutsList);
    }));
  };

  /**
   * Get all the tables that are in this layout
   * @return {Array}
   */
  service.getTablesByLayoutId = function (layoutId) {
    return $q.when(PouchLoadService.getDbLocal().get(layoutId).then(function (layout) {
      var tableIds = layout.tables;
      return PouchLoadService.getDbLocal().allDocs({
        include_docs: true,
        attachments: false,
        keys: tableIds
      });
    }).then(function (tables) {
      return tables.rows.map(function (item) {
        return item.doc;
      });
    }));
  };

  service.roundTablePositions = function (tables) {
    for (var i = tables.length - 1; i >= 0; i--) {
      var position = tables[i].position;
      if (!position) {
        continue;
      }
      if (isFinite(position.x)) {
        position.x = Math.round(position.x);
      }
      if (isFinite(position.y)) {
        position.y = Math.round(position.y);
      }
    }
  };

  service.getTableChanges = function (tables, orgTables) {
    tables = ObjectCopyService.angularSafeCopy(tables);
    var layoutTableIds = [];
    var deletedTables = [];
    var changedTables = [];
    var changedTableNames = [];
    var newTables = [];
    var orgTablesIds = [];

    if (orgTables && orgTables.length) {
      orgTablesIds = orgTables.map(function (table) {
        return table._id;
      });
    }

    for (var i = tables.length - 1; i >= 0; i--) {
      var table = tables[i];

      if (table.markedForDelete) {
        deletedTables.push(table);
      } else {
        layoutTableIds.push(table._id);
        var orgTableIndex = orgTablesIds.indexOf(table._id);
        if (orgTableIndex === -1) {
          // a new table has been added
          newTables.push(table);
        } else {
          //check to see if a table has been changed
          var orgTable = orgTables[orgTableIndex];
          if (table.capacity !== orgTable.capacity) {
            delete table.chairs;
          }
          if (table.capacity < orgTable.capacity || table.minCapacity > orgTable.minCapacity) {
            changedTables.push(table);
          }
          if (table.name !== orgTable.name) {
            changedTableNames.push(table);
          }
        }
      }

      delete table.$$hashKey;
      delete table.markedForDelete;
    }

    return {
      layoutTableIds: layoutTableIds,
      deletedTables: deletedTables,
      changedTables: changedTables,
      changedTableNames: changedTableNames,
      newTables: newTables,
      tables: tables
    };
  };

  service.updateLayout = function (saveDate, layout, tables, orgTables) {
    service.setTablesBookingOptions(tables);

    if (layout.tablesJoins) {
      service.setTablesBookingOptions(layout.tablesJoins);
    }

    var saveDateId = DateUtilsService.dateToIdStr(saveDate);
    // copy the layout
    layout = ObjectCopyService.angularSafeCopy(layout);
    var tableChanges = service.getTableChanges(tables, orgTables);
    tables = tableChanges.tables;
    service.roundTablePositions(tables);
    if (layout.tablesJoins) {
      service.roundTablePositions(layout.tablesJoins);
    }
    var newVersionRequired = false;
    if (tableChanges.newTables.length || tableChanges.changedTables.length || tableChanges.deletedTables.length) {
      newVersionRequired = true;
    }
    // update the layouts table ids
    layout.tables = tableChanges.layoutTableIds;
    // update the layout id.
    var idParts = layout._id.split('_');
    var dateStr = idParts[idParts.length - 1];
    if (dateStr !== saveDateId && newVersionRequired) {
      delete layout._rev;
      // we are going to save this as a new layout
      // so that the old was is kept for past bookings
      // so remove the revision
      idParts.pop();
      idParts.push(saveDateId);
      layout._id = idParts.join('_');
    }

    return $q.when(PouchLoadService.getDbLocal().bulkDocs(tables.concat([layout]))).then(function () {
      TrackingService.trackEvent('Edit Layout', {
        id: layout._id
      });
      return {
        savedLayout: layout,
        deletedTables: tableChanges.deletedTables,
        changedTables: tableChanges.changedTables,
        changedTableNames: tableChanges.changedTableNames
      };
    });
  };

  return service;
}
